import { ComponentProps } from 'react';

export function HelpLibrary({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.95 13.6062L12.5844 1.10938C12.4031 0.44 11.7969 0 11.1375 0C11.009 0 10.8783 0.0166031 10.7481 0.0512813L8.81625 0.566281C8.63234 0.615344 8.46813 0.699344 8.32312 0.804812C8.07187 0.328437 7.575 0 7 0H5C4.725 0 4.47188 0.0790938 4.25 0.208C4.02812 0.0790938 3.775 0 3.5 0H1.5C0.671562 0 0 0.671562 0 1.5V14.5C0 15.3281 0.671562 16 1.5 16H3.5C3.77459 16 4.02875 15.9209 4.25 15.792C4.47188 15.9219 4.725 16 5 16H7C7.82844 16 8.5 15.3284 8.5 14.5V5.16563L11.1187 14.8938C11.3 15.5594 11.9031 16 12.5656 16C12.6941 16 12.8248 15.9834 12.955 15.9487L14.8869 15.4337C15.6875 15.2188 16.1625 14.4 15.95 13.6062ZM7 1.5V3H5V1.5H7ZM5 4.5H7V11.5H5V4.5ZM3.5 11.5H1.5V4.5H3.5V11.5ZM3.5 1.5V3H1.5V1.5H3.5ZM1.5 14.5V13H3.5V14.5H1.5ZM5 14.5L5.00003 13.0281L7 13V14.5H5ZM9.2 2.01562L11.1322 1.50063L11.5219 2.93531L9.5875 3.45L9.2 2.01562ZM9.97812 4.89375L11.9128 4.37781L13.7266 11.1059L11.7919 11.6219L9.97812 4.89375ZM12.5688 14.5031L12.1809 13.0644L14.1156 12.5484L14.5025 13.9841L12.5688 14.5031Z"
        fill="currentColor"
      />
    </svg>
  );
}
